import {LegacyRegulationWrapper} from "./legacy-regulation-wrapper";
import {TimeSpan} from "@sparkware/app-utils";
import {IRealityCheckHandler} from "../session-timer/reality-check/handlers/reality-check-handler.interface";

export abstract class RegulationWithRealityCheck extends LegacyRegulationWrapper {
    abstract createRealityCheckHandler(): IRealityCheckHandler;

    get isSessionTimerEnabled(): boolean {
        return true;
    }

    getRealityCheckInterval(): TimeSpan {
        if(!this.services.user.isAuthorized) {
            return TimeSpan.fromMilliseconds(0);
        }

        if(this.services.user.userData.realityCheckInterval) {
            return this.services.user.userData.realityCheckInterval;
        }

        try {
            return TimeSpan.parse(this.services.configuration.servicesConfigs.Regulation.realityCheckInterval);
        } catch (err) {
            this.services.logger.error(`Failed to parse realityCheckInterval for regulation ${this.name} `);
            return TimeSpan.fromHours(1);
        }
    }
}